import { transformServerFormatToClient as serverToClientButton } from '../../lib/buttonModelV3';
import { transformServerFormatToClient as serverToClientCampaign } from '../../lib/campaignsModel';
import { getServerProps } from '../../utilsV3/serverProps';
import {
  CREATE_DEFAULT_BUTTON,
  CREATE_DEFAULT_BUTTON_SUCCESS,
  CREATE_DEFAULT_BUTTON_ERROR,
  DELETE_BUTTON,
  DELETE_BUTTON_SUCCESS,
  DELETE_BUTTON_ERROR,
  GET_BUTTON,
  GET_BUTTON_SUCCESS,
  GET_BUTTON_ERROR,
  UPDATE_VOUCHER_LISTING_STATUS,
  UPDATE_VOUCHER_LISTING_STATUS_SUCCESS,
  UPDATE_VOUCHER_LISTING_STATUS_ERROR,
} from './actionsManager';
import {
  GET_CAMPAIGN,
  GET_CAMPAIGN_SUCCESS,
  GET_CAMPAIGN_ERROR,
  DELETE_CAMPAIGN,
  DELETE_CAMPAIGN_SUCCESS,
  DELETE_CAMPAIGN_ERROR,
  EDIT_CAMPAIGN_VALUE_SUCCESS,
  EDIT_CAMPAIGN_VALUE_ERROR,
  UPDATE_CAMPAIGN,
} from '../../campaigns/manager/actionsManager';
import {
  SET_COUNT_DONATIONS,
  SET_LAST_UPDATED_DONATION_PAGE,
} from '../../actions/actionsCommon';
import { SET_MANAGE_PAGE_INSIGHTS } from '../../actions/actionsDonationInsights';
import _get from 'lodash/get';

const defaultState = {
  busy: true,
};

const businessProfileLogoUrl =
  _get(getServerProps(), 'businessImageUrls.url') || '';

function getFormattedButton(payload) {
  // organizationName is not stored in BF service
  // fetching from server to make sure it gets pre-filled when user is editing/duplicating a button
  return Object.assign({}, serverToClientButton(payload), {
    receiverName: getServerProps().receiverName,
    language: payload.language,
    offerProgram: payload.offerProgram,
  });
}

function getFormattedCampaign(payload) {
  return Object.assign({}, serverToClientCampaign(payload));
}

export default function buttonManagerV3(state = defaultState, action) {
  switch (action.type) {
    case CREATE_DEFAULT_BUTTON: {
      return {
        ...state,
        isSending: true,
        busy: false,
      };
    }

    case CREATE_DEFAULT_BUTTON_SUCCESS: {
      return {
        ...state,
        isSending: false,
        busy: false,
      };
    }

    case CREATE_DEFAULT_BUTTON_ERROR: {
      return {
        ...state,
        error: action.error,
        isSending: false,
        busy: false,
      };
    }

    case GET_BUTTON: {
      return {
        ...state,
        isSending: true,
        busy: true,
      };
    }

    case GET_BUTTON_SUCCESS: {
      const button = action.payload;
      const formattedButton = getFormattedButton({
        ...button,
        businessImageUrls: action.businessImageUrls,
        merchantExperienceUrls: action.merchantExperienceUrls,
      });

      return {
        ...state,
        button,
        formattedButton,
        isSending: false,
        busy: false,
      };
    }

    case GET_BUTTON_ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isSending: false,
        busy: false,
      };
    }

    case DELETE_BUTTON: {
      return {
        ...state,
        isSending: true,
        busy: false,
      };
    }

    case DELETE_BUTTON_SUCCESS: {
      return {
        ...state,
        isSending: false,
        busy: false,
      };
    }

    case DELETE_BUTTON_ERROR: {
      return {
        ...state,
        error: action.error,
        isSending: false,
        busy: false,
      };
    }

    case UPDATE_VOUCHER_LISTING_STATUS: {
      return {
        ...state,
        isSending: true,
        busy: true,
      };
    }

    case UPDATE_VOUCHER_LISTING_STATUS_SUCCESS: {
      return {
        ...state,
        isSending: false,
        busy: false,
      };
    }

    case UPDATE_VOUCHER_LISTING_STATUS_ERROR: {
      return {
        ...state,
        error: action.error,
        isSending: false,
        busy: false,
      };
    }

    // CAMPAIGNS

    case GET_CAMPAIGN: {
      return {
        ...state,
        isSending: true,
        busy: true,
      };
    }

    case GET_CAMPAIGN_SUCCESS: {
      const campaign = action.payload;
      const formattedCampaign = getFormattedCampaign({
        ...campaign,
        businessImageUrls: action.businessImageUrls,
        businessProfileLogoUrl,
      });

      return {
        ...state,
        campaign,
        formattedCampaign,
        isSending: false,
        busy: false,
      };
    }

    case GET_CAMPAIGN_ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isSending: false,
        busy: false,
      };
    }

    case DELETE_CAMPAIGN: {
      return {
        ...state,
        isSending: true,
        busy: false,
      };
    }

    case DELETE_CAMPAIGN_SUCCESS: {
      return {
        ...state,
        isSending: false,
        busy: false,
      };
    }

    case DELETE_CAMPAIGN_ERROR: {
      return {
        ...state,
        error: action.error,
        isSending: false,
        busy: false,
      };
    }

    case UPDATE_CAMPAIGN: {
      return {
        ...state,
        isSending: true,
        busy: true,
      };
    }

    case EDIT_CAMPAIGN_VALUE_SUCCESS: {
      return {
        ...state,
        formattedCampaign: getFormattedCampaign({
          ...action.payload,
          businessProfileLogoUrl,
        }),
        busy: false,
        error: null,
        isCampaignCreated: false,
      };
    }

    case EDIT_CAMPAIGN_VALUE_ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        busy: false,
      };
    }

    case SET_COUNT_DONATIONS: {
      const count = action?.donationPagesCount || 0;
      return {
        ...state,
        donationPagesCount: count,
        donationPagesState: count > 0 ? 'populated' : 'empty',
      };
    }

    case SET_LAST_UPDATED_DONATION_PAGE: {
      const donationPage = action.payload;
      return {
        ...state,
        lastUpdated: donationPage,
      };
    }

    case SET_MANAGE_PAGE_INSIGHTS: {
      const { insightsSummary, hostedProductsInsights } = action.payload;
      return {
        ...state,
        insightsSummary,
        hostedProductsInsights,
      };
    }

    default:
      return state;
  }
}
